import React, { useEffect, useState } from "react";
import { VStack, Heading, Box, useToast } from "@chakra-ui/react";
import JdGrid from "./JdGrid";
import { useParams } from "react-router-dom";
import axios from "axios";
import { TARM_AWS_URL } from "../../api/api";
import Loading from "../Loading/Loading";
import { getRunID } from "../../util/runID";
import { getSerializedGridRowData } from "./Util";

const EditExistingJobProfile = () => {
  const [source] = useState(axios.CancelToken.source());
  const [serializedRowData, setSerializedRowData] = useState([]);
  const [requiredJobTitle, setRequiredJobTitle] = useState([])
  const { run_id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const toast = useToast()

  useEffect(() => {
    getSavedJd();
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, []);

  const getSavedJd = async () => {
    try {
      const response = await TARM_AWS_URL.get(
        'jd-parser/get-saved-jd', { params: { "run_id": run_id } },
        {
          cancelToken: source.token,
        }
      );
      console.log(response)
      const JD_Skill_weighted_output = response.data.JD_Skill_weighted_output
      const required_job_title = response.data.required_job_title
      const serializedRequiredJobTitles = required_job_title.map(item => ({ "id": item, "text": item }))
      setRequiredJobTitle(serializedRequiredJobTitles)
      const serializedRowData = getSerializedGridRowData(JD_Skill_weighted_output)
      setSerializedRowData(serializedRowData);
    } catch (error) {
      console.error(error);
      toast({
        title: error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <VStack>
      <Heading>Configure JD weights</Heading>
      <br />
      <Box borderWidth="3px" borderRadius="lg" p="10">
        {isLoading ? (
          <Loading loading={isLoading} />
        ) : (
          <JdGrid
            serializedRowData={serializedRowData}
            run_id={getRunID()}
            isEditingExisitingJD="true"
            requiredJobTitle={requiredJobTitle}
          />
        )}
      </Box>
    </VStack>
  );
};

export default EditExistingJobProfile;
